import React from 'react';
import {Button, Form, Modal} from "react-bootstrap";
import './style.css';
import ProjectInfo from "../../data/ProjectInfo";
import {ImCheckboxChecked, ImCheckboxUnchecked} from "react-icons/im";

export default class ChildForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			birth: undefined,
			gender: 'j',
			socken: '',
			project: undefined,
			price: undefined,
			errors: {}
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.birth !== this.state.birth) {
			this.calculateProject(this.state.birth);
		}

		if (prevState.project !== this.state.project) {
			this.setState({price: this.state.project !== "2" ? undefined : "10"});
		}
	}

	getChildData = () => {
		return {
			name: this.state.name,
			birth: this.state.birth,
			gender: this.state.gender,
			socken: this.state.socken,
			project: this.state.project,
			price: this.state.price
		};
	};

	checkRequiredFields = (errors, data, key) => {
		if (!data[key] || data[key].length <= 0) {
			errors[key] = this.props.labels.errors?.required;
		}
	};

	add = () => {
		let errors = {};
		let data = this.getChildData();

		this.checkRequiredFields(errors, data, 'name');
		this.checkRequiredFields(errors, data, 'birth');
		this.checkRequiredFields(errors, data, 'gender');
		this.checkRequiredFields(errors, data, 'project');

		if (this.isProject(data.birth) && (data.socken === '' || data.socken === undefined)) {
			this.checkRequiredFields(errors, data, 'socken');
		}

		if (this.state.project === "-1") {
			errors['birth'] = this.props.labels.getProjectInfo(this.state.project).name;
		}

		if (!Object.keys(errors).length) {
			this.props.add(data);
		}
		else {
			this.setState({errors});
		}
	};

	// From 2018-09-01 till 2021-03-31
	isBambini = (birth) => {
		const birthDate = new Date(birth);
		const startDate = new Date('2018-09-01');
		const endDate = new Date('2021-03-31');
		return birthDate >= startDate && birthDate <= endDate;
	};

	// From 2012-09-01 till 2018-08-18
	/*isStations = (birth) => {
		const birthDate = new Date(birth);
		const startDate = new Date('2012-09-01');
		const endDate = new Date('2018-08-31');
		return birthDate >= startDate && birthDate <= endDate;
	};*/



	// Checks if the child with the passed birthdate is born after 2019-09-30 and younger than 12 years on the 16.02.2026
	isStations = (birth) => {
		const birthDate = new Date(birth);
		const startDate = new Date('2019-09-30');
		const referenceDate = new Date('2026-02-16');

		// Calculate age on reference date
		let age = referenceDate.getFullYear() - birthDate.getFullYear();
		const monthDiff = referenceDate.getMonth() - birthDate.getMonth();
		const dayDiff = referenceDate.getDate() - birthDate.getDate();

		if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
			age--;
		}

		return birthDate <= startDate && age < 12;
	};


	// From 2009-01-01 till 2012-08-31
	/*isProject = (birth) => {
		const birthDate = new Date(birth);
		const startDate = new Date('2009-01-01');
		const endDate = new Date('2012-08-31');
		return birthDate >= startDate && birthDate <= endDate;
	}; */

	// Checks if the child with the passed birthdate is in age between 12 and 16 years
	isProject = (birth) => {
		const birthDate = new Date(birth);
		const today = new Date();

		// Calculate age
		let age = today.getFullYear() - birthDate.getFullYear();
		const monthDiff = today.getMonth() - birthDate.getMonth();
		const dayDiff = today.getDate() - birthDate.getDate();

		if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
			age--;
		}

		return age >= 12 && age <= 16;
	};


	calculateProject = (birth) => {
		/*if (this.isBambini(birth)) {
			this.setState({project: "0"});
		}
		else*/
		if (this.isStations(birth)) {
			this.setState({project: "1"});
		}
		else if (this.isProject(birth)) {
			this.setState({project: "2"});
		}
		else {
			this.setState({project: "-1"});
		}
	};

	render() {
		const l = this.props.labels;
		return (
			<Modal show={this.props.show} centered dialogClassName="modal-add-child">
				<h2>{l.child.topic(this.props.childCount)}</h2>
				<Form>
					<Form.Group className="mb-3">
						<Form.Label>{l.child.name}</Form.Label>
						<Form.Control
							value={this.state.name}
							onChange={(e) => this.setState({name: e.currentTarget.value, errors: {}})}
							type="text"
							isInvalid={this.state.errors['name']}
							placeholder={l.child.placeholder.name}/>
						<Form.Control.Feedback type="invalid">{this.state.errors['name']}</Form.Control.Feedback>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>{l.child.birth}</Form.Label>
						<Form.Control
							value={this.state.birth}
							onChange={(e) => this.setState({birth: e.currentTarget.value, errors: {}})}
							isInvalid={this.state.errors['birth']}
							type="date"/>
						<Form.Control.Feedback type="invalid">{this.state.errors['birth']}</Form.Control.Feedback>
					</Form.Group>
					<Form.Group className="mb-3">
						<Form.Label>{l.child.gender}</Form.Label>
						<Form.Select
							isInvalid={this.state.errors['gender']}
							value={this.state.gender}
							onChange={(e) => this.setState({gender: e.currentTarget.value, errors: {}})}>
							<option value="j">{l.getGender("j")}</option>
							<option value="m">{l.getGender("m")}</option>
						</Form.Select>
						<Form.Control.Feedback type="invalid">{this.state.errors['gender']}</Form.Control.Feedback>
					</Form.Group>

					{this.state.project && <div className={'project-info-container'}>
						<ProjectInfo labels={l} project={this.state.project} day={this.state.day}/>
					</div>}

					{this.state.birth && this.isProject(this.state.birth) && (
						<>
							<Form.Group className="mb-3">
								<Form.Label>{l.child.socken}</Form.Label>
								<Form.Select
									isInvalid={this.state.errors['socken']}
									value={this.state.socken}
									onChange={(e) => this.setState({socken: e.currentTarget.value, errors: {}})}>
									<option value="">Auswählen</option>
									<option value="31-34">31-34</option>
									<option value="35-38">35-38</option>
									<option value="39-41">39-41</option>
									<option value="42-45">42-45</option>
								</Form.Select>
								<Form.Control.Feedback type="invalid">{this.state.errors['socken']}</Form.Control.Feedback>
							</Form.Group>
							<div>
								<b style={{color:"red"}}>Das Kind muss einen Eigenbetrag von 10€ bezahlen, um an dem Projekt teilzunehmen.</b>
							</div>
						</>
					)}
				</Form>

				<div className={'button-container'}>
					<Button variant="secondary" onClick={this.props.close}>{l.cancel}</Button>
					<Button className={'add-child-form-button'} onClick={() => this.add()}>{l.add}</Button>
				</div>
			</Modal>
		);
	}

}
